
<!-- The node -->
<div *ngIf="!node.checkData" app-sec-trim 
    [permissions]="node.permissions" 
    [userTypes]="node.userTypes" >
     <!-- disabled property does not work on Div-tag, css-class used instead in ngClass -->
    <div matRipple 
      class="sx-multilevel-sidenav__list-item"
      [disabled]="node.disabled"
      *ngIf="!node.hidden"
      title="{{node.displayText}}"
      [ngClass]="{'active': useIndexOf(node) ?  appRouter.url.indexOf(node.linkUrl) === 0 : appRouter.url.endsWith(node.linkUrl), 'sx-multilevel-sidenav__list-item--selected': isSelected, 'mdc-list-item--disabled': node.disabled } ">
      <ng-container *ngTemplateOutlet="linkTemplate"></ng-container>
  </div>
</div>

<span *ngIf="node.checkData">
  <div app-sec-trim 
    [permissions]="node.permissions" 
    [userTypes]="node.userTypes" 
    [hidden]="meteringPoints.loaded && meteringPoints.meteringPoints.length === 0">
    <!-- disabled property does not work on Div-tag, css-class used instead in ngClass -->
    <div matRipple
      class="sx-multilevel-sidenav__list-item"
      *ngIf="!node.hidden"
      [disabled]="isWhiteLabel || onlyExternalMeteringPoints"
      title="{{node.displayText}}"
      [ngClass]="{'active': useIndexOf(node) ?  appRouter.url.indexOf(node.linkUrl) === 0 : appRouter.url.endsWith(node.linkUrl), 'sx-multilevel-sidenav__list-item--selected': isSelected, 'mdc-list-item--disabled': isWhiteLabel || onlyExternalMeteringPoints} ">
      <ng-container *ngTemplateOutlet="linkTemplate"></ng-container>
    </div>
  </div>

  <div app-sec-trim 
    [permissions]="node.permissions" 
    [userTypes]="node.userTypes"
    [hidden]="!meteringPoints.loaded || (meteringPoints.loaded && meteringPoints.meteringPoints.length > 0)">
     <!-- disabled property does not work on Div-tag, css-class used instead in ngClass -->
    <div matRipple
      class="sx-multilevel-sidenav__list-item"
      [disabled]="true"
      *ngIf="!node.hidden"
      title="{{node.displayText}}"
      [ngClass]="{'active': useIndexOf(node) ?  appRouter.url.indexOf(node.linkUrl) === 0 : appRouter.url.endsWith(node.linkUrl), 'sx-multilevel-sidenav__list-item--selected': isSelected, 'mdc-list-item--disabled': true} "
      >
      <ng-container *ngTemplateOutlet="linkTemplate"></ng-container>
    </div>
  </div> 
</span> 

<mat-divider></mat-divider>

<!-- Subnodes -->
<div *ngIf="hasItems() && node.expanded" [@slideInOut] dir="ltr" [ngClass]="classes">
  <app-multi-level-menu-item *ngFor="let node of children"
    [node]="node" 
    [level]="level + 1"
    [submenuLevel]="level + 2" 
    [selectedNode]='selectedNode' 
    [isWhiteLabel]="isWhiteLabel || onlyExternalMeteringPoints"
    [onlyExternalMeteringPoints]="onlyExternalMeteringPoints"
    [meteringPoints]="meteringPoints"
    (selectedItem)="selectedListItem($event)">
  </app-multi-level-menu-item>
</div>

<ng-template #linkTemplate>
    <span class="sx-multilevel-sidenav__link" *ngIf="!node.externalRedirect">
      <ng-container *ngTemplateOutlet="linkMenuNode"></ng-container>
    </span>
    <span class="sx-multilevel-sidenav__link" *ngIf="node.externalRedirect">
      <ng-container *ngTemplateOutlet="linkExternalMenuNode"></ng-container>
    </span>
</ng-template>

<ng-template #linkMenuNode>

 <div class="sx-multilevel-sidenav__node-data-container">
  <!-- a-tag -->
    <a (click)="select()" class="sx-multilevel-sidenav__node-data" [routerLink]="node.linkUrl" [state]="{goBackUrl: node.goBackUrl}" [ngStyle]="getListStyle()">
      <div class="sx-multilevel-sidenav__icon-container" *ngIf="hasIcon()">
        <svg class="sx-multilevel-sidenav__icon">
          <use [attr.xlink:href]="node.iconName" [attr.href]="node.iconName" />
        </svg>
      </div>
      <span class="sx-multilevel-sidenav__label" data-cy="multilevel-sidenav-label">{{node.displayText}}</span>
   </a>
 </div>
 <div *ngIf='hasItems()' class="sx-multilevel-sidenav__icon-arrow-container">
    <!-- Button -->
    <button (click)="expand();false">
      <i [ngClass]="node.expanded ?'sx-multilevel-sidenav__icon-arrow-content-up':'sx-multilevel-sidenav__icon-arrow-content'"></i>
      <span class="mat-expansion-indicator material-icons" [@isExpandedLTR]="node.expanded ? 'yes' : 'no'"></span>
    </button>
 </div>
</ng-template>

<ng-template #linkExternalMenuNode>
  <div class="sx-multilevel-sidenav__node-data-container">
    <a class="sx-multilevel-sidenav__node-data" dir="ltr" [href]="node.linkUrl" [target]="getHrefTargetType()" [ngStyle]="getListStyle()">
      <span class="sx-multilevel-sidenav__label">{{node.displayText}}</span>
      <div class="sx-multilevel-sidenav__icon-container" *ngIf="hasIcon()">
        <svg class="sx-sidenav__icon-small sx-sidenav__icon-small--adjusted">
          <use xlink:href="#sx-extern-lank" href="#sx-extern-lank" />
        </svg>
      </div>
    </a>
  </div>
  <div *ngIf='hasItems()' class="sx-multilevel-sidenav__icon-arrow-container">
    <button (click)="expand();false">
      <span class="mat-expansion-indicator material-icons" [@isExpandedLTR]="node.expanded ? 'yes' : 'no'"></span>
    </button>
  </div>
</ng-template>
